import { cn } from "#app/utils/misc.js";

/** NeighborCloud logo for title portal pages — place in the left/info column, not a full-width bar */
export function TitlePortalLogo({ className }: { className?: string }) {
  return (
    <img
      src="/images/logo-blue.svg"
      alt="NeighborCloud"
      className={cn("block h-9 w-auto sm:h-10", className)}
      decoding="async"
    />
  );
}
